import { Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ComparePage } from './pages/ComparePage';
import { Reviews } from './pages/Reviews';
import { ReviewDetailPage } from './pages/ReviewDetailPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { AboutPage } from './pages/AboutPage';
import { AffiliateRedirect } from './components/AffiliateRedirect';
import { LoginPage } from './pages/LoginPage';
import { PasswordResetPage } from './pages/PasswordResetPage';
import { PasswordResetConfirmPage } from './pages/PasswordResetConfirmPage';
import { NewsletterDashboard } from './pages/NewsletterDashboard';
import { useScrollToTop } from './hooks/useScrollToTop';
import { CategoryPage } from './pages/CategoryPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { SubscribePage } from './pages/SubscribePage';
import { ThankYouPage } from './pages/ThankYouPage';
import { NewsletterPopup } from './components/NewsletterPopup';
import { BestPropFirmsPage } from './pages/BestPropFirmsPage';

function App() {
  useScrollToTop();
  const location = useLocation();

  return (
    <>
      {location.pathname === '/' && <NewsletterPopup />}

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="compare" element={<ComparePage />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="reviews/:firmSlug" element={<ReviewDetailPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          <Route path="testimonials" element={<TestimonialsPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="go/:firmId" element={<AffiliateRedirect />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="reset-password" element={<PasswordResetPage />} />
          <Route path="reset-password/confirm" element={<PasswordResetConfirmPage />} />
          <Route path="newsletter-dashboard" element={<NewsletterDashboard />} />
          <Route path="blog/category/:slug" element={<CategoryPage />} />
          <Route path="terms-of-use" element={<TermsOfUsePage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="subscribe" element={<SubscribePage />} />
          <Route path="thank-you" element={<ThankYouPage />} />
          <Route path="best-prop-firms" element={<BestPropFirmsPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
